// src/pages/RegistrationFuiteDonnees/components/RegistrationHeader.tsx
import React from 'react';
import logo from 'assets/img/logo_ID-Protect.png'; // PNG/JPG logo
import './RegistrationHeader.scss';

const RegistrationHeader = () => {
  return (
    <div className="registration-header">
      <div className="registration-header__logo-container">
        <img
          src={logo}
          width={100}
          alt="ID Protect"
          className="registration-header__logo"
        />
      </div>
    </div>
  );
};

export default RegistrationHeader;